import gql from 'graphql-tag';

// eslint-disable-next-line import/prefer-default-export
export const publicProfileQuery = gql`
  query getPublicProfileOrganizationByPk($organizationId: uuid!) {
    organization_by_pk(id: $organizationId) {
      name
      description
      tax_id
      contact_name
      contact_email
      country
      city
      address
      created_date
      last_billing
    }
  }
`;

export const searchOrganizationsQuery = gql`
  query searchOrganizations($keyword: String) {
      organization(where: {_or: [{name: {_like: $keyword}}, {tax_id: {_like: $keyword}}]}) {
        id
        name
        tax_id
      }
  }
`;



// WEBPACK FOOTER //
// ./src/store/graphql/queries/organization.js